import React, { useState } from "react";
import Language from "../lib/Language";
import { SimpleDateFormat, MillenniumDate } from "@timeedit/millennium-time";

const getSeparator = (format) => {
    let found = "-";
    [".", "-", "/"].forEach((separator) => {
        if (format.indexOf(separator) !== -1) {
            found = separator;
        }
    });
    return found;
};

const orderDateComponents = (dateArray, format, separator) => {
    const result: any = [];
    const componentOrder = format.split(separator);
    componentOrder.forEach((component, index) => {
        if (component.indexOf("y") !== -1) {
            result[0] = dateArray[index];
        }
        if (component.toLowerCase().indexOf("m") !== -1) {
            result[1] = dateArray[index];
        }
        if (component.indexOf("d") !== -1) {
            result[2] = dateArray[index];
        }
    });
    return result;
};

const format = (date: MillenniumDate) =>
    SimpleDateFormat.format(date, Language.getDateFormat("date_i_yyyy_mm_dd"));

type TDateInputProps = {
    defaultValue: MillenniumDate;
    onUpdate: (value: MillenniumDate) => void;
    disabled?: boolean;
};

const DateInput = ({ defaultValue, onUpdate, disabled = false }: TDateInputProps) => {
    const [value, setValue] = useState(format(defaultValue));

    // Replaces componentDidUpdate(prevProps): re-sync only when the incoming value
    // changed, so a half-typed date is not overwritten mid-edit.
    const [prevDefault, setPrevDefault] = useState(defaultValue);
    if (defaultValue !== prevDefault) {
        setPrevDefault(defaultValue);
        const next = format(defaultValue);
        if (next !== value) {
            setValue(next);
        }
    }

    const onChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
        setValue(evt.target.value);
    };

    const returnValue = () => {
        const dateFormat = Language.getDateFormat("date_i_yyyy_mm_dd");
        const separator = getSeparator(dateFormat);
        const dateArray = value.split(separator).map((str) => parseInt(str, 10));
        const sortedArray = orderDateComponents(dateArray, dateFormat, separator);
        try {
            const date = MillenniumDate.create.apply(null, sortedArray);
            onUpdate(date);
        } catch (error) {
            setValue(format(defaultValue));
            onUpdate(defaultValue);
        }
    };

    return (
        <input
            disabled={disabled}
            type="text"
            value={value}
            onChange={onChange}
            onBlur={returnValue}
        />
    );
};

export default DateInput;
